import React, { useState } from "react";
import { TrendingUp, Target, Shield } from "react-feather";
import "../MarketPositionNew.css";


const ExecutiveOverview = () => {
  const [selectedCompanyBreakdown, setSelectedCompanyBreakdown] =
    useState(null);

  const scoreBreakdown = {
    henkel: {
      overall: 8.5,
      dimensions: [
        {
          name: "Share Rank",
          score: 9,
          explanation: "Henkel leads as #1 global player with largest scale",
        },
        {
          name: "Geographic Mix",
          score: 8.5,
          explanation: "Henkel operates in 55 countries with 161 facilities",
        },
        {
          name: "Segment Mix",
          score: 8.5,
          explanation:
            "All players serve 30+ market segments. Henkel particularly strong in construction (largest segment)",
        },
        {
          name: "Customer Satisfaction",
          score: 7.5,
          explanation:
            "Large players like H.B. Fuller, Henkel, and Bostik maintain good satisfaction through technical support and scale",
        },
        {
          name: "Concentration Risk",
          score: 9,
          explanation:
            "Henkel most diversified (50% adhesives, 50% consumer brands). Very low concentration risk",
        },
      ],
    },
    hbfuller: {
      overall: 7.6,
      dimensions: [
        {
          name: "Share Rank",
          score: 7,
          explanation:
            "H.B. Fuller is #4 globally and largest pure-play adhesives company",
        },
        {
          name: "Geographic Mix",
          score: 7.5,
          explanation:
            "H.B. Fuller distributes to 140+ countries with 81 manufacturing facilities",
        },
        {
          name: "Segment Mix",
          score: 8,
          explanation:
            "H.B. Fuller leads in hygiene/nonwovens and specialty applications",
        },
        {
          name: "Customer Satisfaction",
          score: 7.5,
          explanation:
            "Large players maintain good satisfaction through technical support",
        },
        {
          name: "Concentration Risk",
          score: 8,
          explanation: "H.B. Fuller 100% adhesives creates focus",
        },
      ],
    },
    bostik: {
      overall: 7.4,
      dimensions: [
        {
          name: "Share Rank",
          score: 7.5,
          explanation: "Bostik #3 globally with diversified business model",
        },
        {
          name: "Geographic Mix",
          score: 7.5,
          explanation: "Bostik has balanced global presence",
        },
        {
          name: "Segment Mix",
          score: 7,
          explanation: "Bostik particularly strong in construction",
        },
        {
          name: "Customer Satisfaction",
          score: 7.5,
          explanation: "Strong satisfaction through scale and support",
        },
        {
          name: "Concentration Risk",
          score: 7.5,
          explanation: "Arkema ownership provides diversification benefit",
        },
      ],
    },
    tailored: {
      overall: 5.1,
      dimensions: [
        {
          name: "Share Rank",
          score: 4,
          explanation: "Tailored Chemical is small regional player",
        },
        {
          name: "Geographic Mix",
          score: 4,
          explanation: "Limited to US only with just 4 facilities",
        },
        {
          name: "Segment Mix",
          score: 5.5,
          explanation: "Narrow focus on woodworking niche only",
        },
        {
          name: "Customer Satisfaction",
          score: 7.5,
          explanation: "Good satisfaction through customization",
        },
        {
          name: "Concentration Risk",
          score: 4.5,
          explanation: "Very high concentration risk",
        },
      ],
    },
  };

  const companies = [
    {
      company: "Henkel",
      companyId: "henkel",
      score: "8.5/10",
      status: "Market leader",
      insight: "Defending position with scale",
      colorClass: "bg-danger",
      width: "85%",
    },
    {
      company: "H.B. Fuller (Us)",
      companyId: "hbfuller",
      score: "7.6/10",
      status: "Strong player",
      insight: "Hygiene leadership driving momentum",
      colorClass: "bg-primary",
      width: "76%",
    },
    {
      company: "Bostik",
      companyId: "bostik",
      score: "7.4/10",
      status: "Rising fast",
      insight: "Arkema funding fueling growth",
      colorClass: "bg-info",
      width: "74%",
    },
    {
      company: "Tailored Chemical",
      companyId: "tailored",
      score: "5.1/10",
      status: "Regional niche",
      insight: "Small US-only woodworking player",
      colorClass: "bg-secondary",
      width: "51%",
    },
  ];

  return (
    <div>
      <style>{`
        .executive-summary-card {
          border-bottom: 1px solid #e9ecef;
          background-color: #f7f9ff;
          padding: 12px;
          border: solid 1px #98a4aa33;
          border-radius: 8px;
          margin-bottom: 10px;
        }
        .exe_summary {
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
          color: #1e1c25;
        }
        .summary-icon-box {
          width: 3.5rem;
          height: 3.5rem;
          background: #fff;
          border-radius: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .stat-card {
          padding: 12px 15px;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          border: 1px solid #eee;
          position: relative;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 12px;
          text-align:center;
        }
        .score_inter{
          font-weight: 400;
          font-size: 12px;
          background-color: #f0f4fa;
          line-height: 1.4;
          color: rgba(0, 0, 0, 0.6);
          /* margin-top: 5px; */
          margin-bottom: 20px;
          padding: 12px 8px 12px 12px;
          border-radius: 8px;
        }
        .stat-card-text {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom: 0.5rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .stat-card-value {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 0.25rem;
          line-height: 1;
          color: #000;

        }
        .stat-card-label {
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;

        }
        .bottom-line-card {
          padding: 12px 15px;
          border-radius: 8px;
          background: #fff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          transition: all 0.2s ease;
          border: 1px solid #eee;
          position: relative;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 12px;
          text-align: center;
        }
        .bottom-line-card p{
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom:0px;
        }
        .sub_para{
          color: #5c5c64;
          font-size: 12px;
          font-weight: 400;
          margin-bottom:0px;
        }
        .threat-card {
          padding: 12px 16px;
          border-radius: 8px;
          border: 1px solid;
          height: 100%;
        }
        .threat-card-high {
          background-color: #fef2f2;
          border: 1px solid #b91c1c29;
        }
        .number_danger, .badge_danger{
          background-color:#b91c1c !important;
          border-radius:5px !important;
        }
        .list_li{
          font-weight: 400;
          font-size: 12px;
          line-height: 17.4px;
          margin-bottom: 10px;
          color: #1e1c25;
          align-items: start;
          display: flex;
        }
        .dot_list{
          margin-right:5px;
        }
        .text-warning-med{

        }
        .score{
          font-size:12px;
        }
        .threat-card-medium {
          background-color: #eff6ff;
          border: 1px solid #2563eb29;
        }
        .number_med, .number_badge_med{
          background-color:#1e74e6 !important;
          color:#fff !important;
        }
        .number_low, .number_badge_low{
          background-color:#15803d !important;
          color:#fff !important;
        }
        .threat-card-low {
          background-color: #f0fdf4;
          border: 1px solid #15803d29;
        }
        .score-bar-container {
          height: 13px;
          background: #e9ecef;
          border-radius: 8px;
          overflow: hidden;
          position: relative;
        }
        .score-bar {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 1rem;
          transition: all 0.5s ease;
          cursor: pointer;
          font-size:12px;
        }
        .score-bar:hover {
          opacity: 0.9;
          transform: scaleY(1.05);
        }
        .company-card {
          margin-bottom: 1rem;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          padding: 10px 16px;
        }
        .company-card-highlight {
          background: #e7f3ff;
          border: 2px solid #0d6efd;
          box-shadow: 0 4px 10px rgba(13,110,253,0.2);
        }
        .breakdown-card {
          background: #f7fbff;
          border-radius: 6px;
          padding: 16px 12px;
          border: 1px solid #cedcff;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          margin-top: 16px;
          margin-bottom: 16px;
        }
        .dimension-card {
          background: #fff;
          border-radius: 0.5rem;
          padding: 1rem;
          transition: all 0.3s ease;
        }
        .dimension-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }
        .dimension-progress {
          height: 0.5rem;
          background: #e9ecef;
          border-radius: 1rem;
          overflow: hidden;
          position: relative;
        }
        .dimension-progress-bar {
          height: 100%;
          background: linear-gradient(90deg, #0d6efd 0%, #0b5ed7 100%);
          transition: width 0.5s ease;
        }
        .priority-card {
          position: relative;
          padding: 12px 16px;
          border-radius: 8px;
          border: 1px solid;
          height: 100%;
        }
        .priority-number {
          position: absolute;
          top: -0.75rem;
          left: -0.75rem;
          width: 24px;
          height: 24px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 14px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        }
        .priority-defend {
          background-color: #fef2f2;
          border: 1px solid #B91C1C29;
        }
        .attack_number{
          background-color:#1e74e6 !important;
        }
        .defend_number{
          background-color:#b91c1c !important;
        }
        .avoid_number{
          background-color:#15803d !important;
        }
        .priority-attack {
          background-color: #eff6ff;
          border: 1px solid #2563EB29;
        }
        .priority-avoid {
          background-color: #f0fdf4;
          border: 1px solid #15803D29;
        }
        .main_head_strat{
          font-weight: 600;
          font-size: 14px;
          line-height: 17.5px;
        }
        .main_subhead_strat{
          font-weight: 600;
          font-size: 13px;
          line-height: 17.5px;
        }
        .action-item {
          display: flex;
          align-items: flex-start;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
          font-weight: 400;
          font-size: 12px;
          line-height: 17.4px;
          margin-bottom: 10px;
          color: #1e1c25;
        }
        .company_name_item{
          font-weight: 600;
          font-size: 13px;
          line-height: 17.5px;
          color: #1e1c25;
        }
        .close-button {
    background: #fff;
    border: none;
    border-radius: 0.375rem;
    padding:5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}
.score_details_head{
  font-size:14px;
  margin-bottom:0px;
}
.overall_score_number{
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  line-height: 1;
  color: #0d6efd;
}
.overall_score_head{
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  line-height: 1;
  color: #000; 
}
.overall_sub_text{
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 5px;
  line-height: 1;
  color: #64748B;
}
      `}</style>

      {/* Executive Summary */}
      <div className="executive-summary-card">
        <div className="d-flex align-items-start gap-2 mb-2">
          {/* <div className="summary-icon-box">
            <TrendingUp className="text-primary" size={28} />
          </div> */}
          <div>
            <h2 className="exe_summary ml-1">Executive Summary</h2>
          </div>
        </div>

        <div className="row g-3 mb-3">
          <div className="col-md-4">
            <div className="stat-card d-block">
              <div className="stat-card-text">H.B. Fuller Strength</div>
              <div className="stat-card-value">7.6/10</div>
              <div className="stat-card-label">Strong Competitor</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-card d-block">
              <div className="stat-card-text">Closest Competitor</div>
              <div className="stat-card-value">Bostik 7.4/10</div>
              <div className="stat-card-label">Within striking distance</div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="stat-card d-block">
              <div className="stat-card-text">Market Leader</div>
              <div className="stat-card-value">Henkel 8.5/10</div>
              <div className="stat-card-label">Dominant player</div>
            </div>
          </div>
        </div>

        <div className="bottom-line-card">
          <p className="">
            <strong>Bottom Line:</strong> H.B. Fuller scores 7.6/10 in
            competitive strength among key players. The company's specialized
            adhesives focus enables deep expertise. Henkel's significantly
            larger facility network (8.5/10) remains the primary threat, while
            Bostik (7.4/10) trails closely behind.
          </p>
        </div>
      </div>

      {/* Threat Assessment */}
      <div className="card border-0  mb-2">
        <div className="card-body">
          <h3 className="exe_summary">Threat Assessment</h3>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="threat-card threat-card-high card_high_threat">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex gap-2">
                    <div
                      className="bg-danger text-white rounded p-2 number_danger fw-bold "
                 
                    >
                      8.5
                    </div>
                    <div>
                      <div className="fw-bold font13">Henkel</div>
                      <div className="text-muted score">Score: 8.5/10</div>
                    </div>
                  </div>
                  <span className="badge bg-danger badge_danger font11">HIGH THREAT</span>
                </div>
                <div className="small">
                  <div className="mb-2 list_li">
                    <span className="text-danger-high fw-bold dot_list">• </span>
                    <span><strong>Massive scale advantage:</strong> Significantly
                    larger facility network</span>
                  </div>
                  <div className="mb-2 list_li">
                    <span className="text-danger-high fw-bold dot_list">• </span>
                    <span><strong>Financial muscle:</strong> Consumer division
                    provides stable cash flow.</span>
                  </div>
                  <div className="list_li">
                    <span className="text-danger-high fw-bold dot_list">• </span>
                    <span><strong>Premium positioning:</strong> Dominates high-value
                    segments</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="threat-card threat-card-medium">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex gap-2">
                    <div
                      className="bg-info text-white rounded p-2 fw-bold number_med">
                      7.4
                    </div>
                    <div>
                      <div className="fw-bold font13">Bostik</div>
                      <div className="small text-muted score">Score: 7.4/10</div>
                    </div>
                  </div>
                  <span className="badge bg-warning text-dark number_badge_med font11">
                    MEDIUM THREAT
                  </span>
                </div>
                <div className="small">
                  <div className="mb-2 list_li">
                    <span className="text-warning-med fw-bold dot_list">• </span>
                    <span> <strong>Construction dominance:</strong> Leads building
                    segment</span>
                  </div>
                  <div className="mb-2 list_li">
                    <span className="text-warning-med fw-bold dot_list">• </span>
                    <span><strong>Arkema backing:</strong> Parent company provides
                    funding</span>
                  </div>
                  <div className="list_li">
                    <span className="text-warning-med fw-bold dot_list">• </span>
                    <span><strong>Close behind:</strong> Trails by only 0.2 points</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="threat-card threat-card-low">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex gap-2">
                    <div
                      className="bg-secondary text-white rounded p-2 fw-bold number_low"
                                   >
                      5.1
                    </div>
                    <div>
                      <div className="fw-bold font13">Tailored</div>
                      <div className="small text-muted score">Score: 5.1/10</div>
                    </div>
                  </div>
                  <span className="badge bg-success number_badge_low font11">LOW THREAT</span>
                </div>
                <div className="small ">
                  <div className="mb-2 list_li">
                    <span className="text-success-low fw-bold dot_list">• </span>
                    <span> <strong>Very small footprint:</strong> Limited to US
                    woodworking niche</span>
                  </div>
                  <div className="mb-2 list_li">
                    <span className="text-success-low fw-bold dot_list">• </span>
                    <span> <strong>No global reach:</strong> Zero international
                    presence</span>
                  </div>
                  <div className="list_li">
                    <span className="text-success-low fw-bold dot_list">• </span>
                    <span><strong>Acquisition opportunity:</strong> Potential target
                    for purchase</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How We Compare */}
      <div className="card border-0">
        <div className="card-body">
          <h3 className="exe_summary">How We Compare</h3>
          <p className="sub_para mb-2">
            Scores reflect overall competitive strength based on scale,
            capabilities, market position, and growth trajectory.
          </p>

          <div className="sub_para mb-3 d-flex justify-content-between align-items-center">
            <div className="text-muted">
              <strong>Note:</strong> Scores based on analysis of 4 key
              competitors.
            </div>
            <div className="d-flex gap-3">
              <div className="d-flex align-items-center gap-1">
                <div
                  className="bg-danger"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    borderRadius: "2px",
                  }}
                ></div>
                <span className="text-muted">Market Leader (8.5+)</span>
              </div>
              <div className="d-flex align-items-center gap-1">
                <div
                  className="bg-info"
                  style={{
                    width: "0.75rem",
                    height: "0.75rem",
                    borderRadius: "2px",
                  }}
                ></div>
                <span className="text-muted">Strong Player (7.5-8.5)</span>
              </div>
            </div>
          </div>

          {companies.map((item, idx) => (
            <div key={idx}>
              <div
                className={`company-card ${
                  idx === 1 ? "company-card-highlight" : ""
                }`}
              >
                <div className="row align-items-center">
                  <div className="col-md-3">
                    <div className="fw-bold company_name_item">{item.company}</div>
                    <div className="small text-muted sub_para">{item.status}</div>
                  </div>
                  <div className="col-md-9">
                    <div className="score-bar-container">
                      <div
                        className={`score-bar ${item.colorClass}`}
                        style={{ width: item.width }}
                        onClick={() =>
                          setSelectedCompanyBreakdown(
                            selectedCompanyBreakdown === item.companyId
                              ? null
                              : item.companyId
                          )
                        }
                        title="Click to see score breakdown"
                      >
                        <span className="text-white fw-bold fs-9">
                          {item.score}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="small text-muted fst-italic sub_para"
                  style={{ marginLeft: "26%", marginTop:"-10px" }}
                >
                  {item.insight}
                </div>
              </div>

              {selectedCompanyBreakdown === item.companyId && (
                <div className="breakdown-card">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="score_details_head">
                      {item.company} Score Details
                    </h4>
                    <button
                      onClick={() => setSelectedCompanyBreakdown(null)}
                      className="close-button"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#6610f2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                  </div>

                  <div className="bg-white rounded p-3 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span className="overall_score_head">Overall Score</span>
                      <span className="overall_score_number">
                        {scoreBreakdown[item.companyId].overall}/10
                      </span>
                    </div>
                    <div className="overall_sub_text">
                      Calculated from 5 sub-dimensions below
                    </div>
                  </div>

                  <div className="row g-3">
                    {scoreBreakdown[item.companyId].dimensions.map(
                      (dim, dimIdx) => (
                        <div key={dimIdx} className="col-12">
                          <div className="dimension-card">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div className="flex-grow-1">
                                <div className="d-flex align-items-center gap-2 mb-2">
                                  <span className="overall_score_head mb-0">
                                    {dim.name}
                                  </span>
                                  <span className="badge bg-primary">
                                    {dim.score}/10
                                  </span>
                                </div>
                                <div className="dimension-progress">
                                  <div
                                    className="dimension-progress-bar"
                                    style={{ width: `${dim.score * 10}%` }}
                                  ></div>
                                </div>
                              </div>
                            </div>
                            <p className="overall_sub_text">
                              {dim.explanation}
                            </p>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              )}
            </div>
          ))}

          <div className="score_inter">
            <strong>Score Interpretation:</strong> 8.5-10 = Dominant market
            leader | 7.5-8.5 = Strong competitive player | 7-7.5 = Solid
            position
          </div>
        </div>
      </div>

      {/* Strategic Priorities */}
      <div className="card border-0 mb-4">
        <div className="card-body">
          <h3 className="exe_summary mb-3">Strategic Priorities</h3>
          <div className="row g-3">
            <div className="col-md-4">
              <div className="priority-card priority-attack">
                <div className="priority-number priority-number-attack bg-primary text-white attack_number">1</div>
                <h4
                  className="main_head_strat"
                  style={{ minHeight: "auto" }}
                >
                  ATTACK
                </h4>
                <div className="main_subhead_strat mb-3">
                  Pursue White Space
                </div>
                <div className="small">
                  <div className="action-item">
                    <Target className="text-primary1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Win in Asia:</strong> Accelerate APAC
                      manufacturing presence
                    </div>
                  </div>
                  <div className="action-item">
                    <Target className="text-primary1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Enter medical goldmine:</strong> Capture
                      high-margin healthcare segment
                    </div>
                  </div>
                  <div className="action-item">
                    <Target className="text-primary1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Steal mid-market construction:</strong> Target
                      value-conscious contractors
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="priority-card priority-defend">
                <div className="priority-number bg-danger text-white defend_number">2</div>
                <h4
                  className="main_head_strat"
                  style={{ minHeight: "auto" }}
                >
                  DEFEND
                </h4>
                <div className="main_subhead_strat mb-3">
                  Protect Your Strengths
                </div>
                <div className="small">
                  <div className="action-item">
                    <Shield className="text-danger1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Guard hygiene dominance:</strong> Protect
                      leadership position in hygiene/nonwovens
                    </div>
                  </div>
                  <div className="action-item">
                    <Shield className="text-danger1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Keep air filtration lead:</strong> Maintain
                      dominance where technical barriers exist
                    </div>
                  </div>
                  <div className="action-item">
                    <Shield className="text-danger1 flex-shrink-0" size={16} />
                    <div>
                      <strong>Beat scale with smarts:</strong> Counter Henkel's
                      size with specialized expertise
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="priority-card priority-avoid">
                <div className="priority-number bg-warning text-white avoid_number">3</div>
                <h4
                  className="main_head_strat"
                  style={{ minHeight: "auto" }}
                >
                  AVOID
                </h4>
                <div className="main_subhead_strat mb-3">
                  Minimize Risk Exposure
                </div>
                <div className="small">
                  <div className="action-item">
                    <div
                      className="border border-warning1 rounded flex-shrink-0"
                      style={{ width: "1rem", height: "1rem" }}
                    ></div>
                    <div>
                      <strong>Henkel's scale advantage:</strong> Don't compete
                      head-to-head on cost
                    </div>
                  </div>
                  <div className="action-item">
                    <div
                      className="border border-warning1 rounded flex-shrink-0"
                      style={{ width: "1rem", height: "1rem" }}
                    ></div>
                    <div>
                      <strong>Crowded construction:</strong> Reduce exposure
                      where Henkel/Bostik dominate
                    </div>
                  </div>
                  <div className="action-item">
                    <div
                      className="border border-warning1 rounded flex-shrink-0"
                      style={{ width: "1rem", height: "1rem" }}
                    ></div>
                    <div>
                      <strong>Geographic concentration:</strong> Don't
                      over-invest in North America
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveOverview;
